import client_list from './images/client_list.jpg';
import './css/AboutUs.css';

function AboutUs() {
    return (
        <div className="about-us">
          <img src={client_list} alt="Gill Associates Photography - A Full Service studio" />
        </div>
    );
}

export default AboutUs;
